<template>
    <div class="d-flex flex-column justify-content-between min-viewport-height">
        <Header class="mb-lg-5"/>

        <div class="container mb-4">
            <div class="stepper mb-4">
                <div class="stepper-toolbar">
                    <div class="row justify-content-center">
                        <div class="col-12">
                            <div class="stepper-toolbar-nav">

                                <WizardCustom
                                    v-for="(step, index) in steps" :key="index"
                                    :stepNumber="stepNumber"
                                    :step="step"
                                    :activeStep="activeStep"
                                    :index="index"
                                >
                                </WizardCustom>
                                <!-- <a href="javascript:void(0)"
                                    v-if="(stepNumber==3 && index==2)||index<2"
                                   :class="{'active': index === activeStep, 'completed': step.isCompleted}"
                                   >

                                    <span>{{ index + 1 }}</span>
                                    {{ step.title }}
                                </a> -->

                            </div>
                        </div>
                    </div>
                </div>

                <div class="stepper-body">
                    <div class="row justify-content-center">
                        <div class="col-lg-11 col-xl-9">
                            <transition name="slide" mode="out-in">
                                <keep-alive>
                                    <component :is="currentStep"></component>
                                </keep-alive>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Footer/>
    </div>
</template>

<script>
import StepOne from './Steps/StepOne';
import StepTwo from './Steps/StepTwo';
import StepThree from './Steps/StepThree';
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import WizardCustom from './WizardCustom';

export default {
    mixins: [nccregistrarMixin],
    components: {Footer, Header, StepOne, StepTwo, StepThree, WizardCustom},
    data() {
        return {
            steps: [
                {
                    title: 'Your Info',
                    isCurrent: true,
                    isCompleted: true,
                    disabledClass: false,
                    component: StepOne
                },
                {
                    title: 'Verification',
                    isCurrent: false,
                    isCompleted: false,
                    disabledClass: true,
                    component: StepTwo
                },
                {
                    title: 'Review',
                    isCurrent: false,
                    isCompleted: false,
                    disabledClass: true,
                    component: StepThree
                }
            ],
            activeStep: 0,
            last_inserted_id: -1,
            is_third_party_enrollment: 0,
            stepNumber: 3,
            currentStep: StepOne,
            paymentSummery: {
                transcript_type: '',
                transcript_owner: '',
                transcript_price: 0,
                delivery_charge: 0,
                total: 0
            }
        }
    },
    created() {
        setTimeout(() => {
            document.querySelector('.generic-error').innerHTML = '';
        }, 500);
    },
    methods: {
        clickStepOneForward() {
            document.querySelector('.generic-error').innerHTML = '';
            var self = this;
            let fs = new FormData(document.getElementById("frmFirst"));
            fs.append("stepNumber", this.stepNumber);
            let tempData = JSON.parse(sessionStorage.getItem('stepOneData'));
            if (tempData && tempData.id) {
                fs.append('id', tempData.id);
            }

            axios.post(this.baseUrl + "/process/registrar-submit-one", fs)
                .then((response) => {
                    if (response.data.success) {
                        self.last_inserted_id = response.data.last_inserted_id;
                        if (tempData && (tempData.id || tempData.is_verified)) {
                            this.nextStep(2, StepThree);
                        } else {
                            this.nextStep(1, StepTwo);
                        }
                    } else {
                        document.querySelector('.generic-error').innerHTML = '<span class="require">*</span> ' + response.data.message;
                    }

                    vueEvent.$emit('buttonLoader', false);
                })
                .catch((e) => {
                    vueEvent.$emit('buttonLoader', false);
                    console.log("Error: " + e.message);
                });
        },
        clickStepTwoForward() {
            var self = this;
            let fs = new FormData(document.getElementById("frmSecond"));
            fs.append("stepNumber", self.stepNumber);
            fs.append("last_inserted_id", self.last_inserted_id);
            axios.post(this.baseUrl + "/process/registrar-submit-two", fs)
                .then((response) => {
                    vueEvent.$emit('buttonLoader', false);
                    if (response.data.success) {
                        let data = JSON.parse(sessionStorage.getItem('stepOneData'));
                        data.is_verified = true;
                        data.id = self.last_inserted_id;
                        sessionStorage.setItem('stepOneData', JSON.stringify(data));

                        /*if (self.stepNumber == 2) {
                            self.clickStepThreeForward(self.stepNumber);
                        } else {
                        }*/
                        self.nextStep(2, StepThree);
                    } else {
                        document.querySelector('.generic-error').innerHTML = '<span class="require">*</span> ' + response.data.message;
                    }
                })
                .catch((e) => {
                    vueEvent.$emit('buttonLoader', false);
                    console.log("Error: " + e.message);
                });
        },
        clickStepThreeForward(localData) {
            var self = this;
            let fs;
            /*if (localData == 2) {
                fs = new FormData(document.getElementById("frmSecond"));
            } else {*/
                fs = new FormData(document.getElementById("frmThree"));
            // }
            fs.append("stepNumber", this.stepNumber);

            fs.append("last_inserted_id", this.last_inserted_id);
            axios
                .post(this.baseUrl + "/process/registrar-submit-three", fs)
                .then((response) => {
                    vueEvent.$emit('buttonLoader', false);
                    if (response.data.success) {
                        self.activeStep = 0;
                        self.$router.push("/success")
                    } else {
                        document.querySelector('.generic-error').innerHTML = '<span class="require">*</span> ' + response.data.message;
                    }
                })
                .catch((e) => {
                    vueEvent.$emit('buttonLoader', false);
                    console.log("Error: " + e.message);
                });
        },
        backStepThree() {
            var activeStep = this.activeStep;
            this.nextStep(2, StepThree);
            this.activeStep = activeStep;
        },
        backStepTwo() {
            var activeStep = this.activeStep;
            this.nextStep(1, StepTwo);
            this.activeStep = activeStep;
        },
        backStepOne() {
            var activeStep = this.activeStep;
            this.nextStep(0, StepOne);
            this.activeStep = activeStep;
        },
        nextStep(index, currentStep) {
            this.activeStep = index;
            this.currentStep = currentStep;

            for (let i = 0; i < this.steps.length; i++) {
                if (i <= index) {
                    this.steps[i].isCurrent = (i == index);
                    this.steps[i].isCompleted = true;
                    this.steps[i].disabledClass = false;
                } else {
                    this.steps[i].isCurrent = false;
                    this.steps[i].isCompleted = false;
                    this.steps[i].disabledClass = true;
                }
            }
        },
        setPaymentSummery(data) // here data is a FormData object
        {
            if (data.get('enrollment_type') == 4) {
                this.stepNumber = 2;
                return;
            }

            let transcript_type = data.get('transcript_type');
            let is_delivered = (data.get('transcript_receieve_type') == 4);
            let shipping_charge = data.get('shipping_method') && (data.get('shipping_method') == 3) ? 40 : 0;
            this.paymentSummery.transcript_owner = data.get('name');
            if (transcript_type == 1) {
                this.paymentSummery.transcript_type = 'Official Transcript';
                this.paymentSummery.transcript_price = 5;
            }
            if (transcript_type == 4) {
                this.paymentSummery.transcript_type = 'Diploma';
                this.paymentSummery.transcript_price = 10;
            }

            if (is_delivered && shipping_charge) {
                //this.paymentSummery.delivery_charge = shipping_charge;
            }
            this.paymentSummery.total = this.paymentSummery.transcript_price + this.paymentSummery.delivery_charge;
        }
    }
};
</script>
